import { AlertService } from '../../shared/services/alert.service';
import { OnInit } from '@angular/core';
import { AssessmentService } from '../../shared/services/assessment.service';
import { QuestionFactoryService } from '../../shared/services/question-factory.service';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionType } from 'app/shared/models/question-type';
import { FlaggedCondition } from 'app/shared/models/flagged-condition';
import { QuestionSetType } from "app/shared/models/question-set-type";
var QuestionEditComponent = /** @class */ (function () {
    function QuestionEditComponent(assessmentService, questionFactory, alertService, router, route) {
        this.assessmentService = assessmentService;
        this.questionFactory = questionFactory;
        this.alertService = alertService;
        this.router = router;
        this.route = route;
        this.SAVE_TIME = 1500;
        this.ERROR_MESSAGE_TIME = 3000;
        this._question = this.questionFactory.createDefaultEmptyQuestion();
        this._flagDirectionList = [
            { id: 'greaterOrEqual', 'name': "Greater than or equal to" },
            { id: 'lessOrEqual', 'name': "Less than or equal to" }
        ];
    }
    QuestionEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            var setId = params['setId'];
            var questionId = params['questionId'];
            _this.assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this.assessment = assessment;
                _this.questionSet = assessment.question_sets.find(function (s) { return s.id == setId; });
                _this._question = (_this.questionSet) ? _this.questionSet.questions.find(function (q) { return q.id == questionId; }) : null;
                if (!(_this.questionSet && _this._question)) {
                    // TODO: stephen should we navigate back?? or do some kind of 404?
                    _this.router.navigate(["not-found"]);
                }
                // if only one scale remains on the edit, make sure it's always the most current.
                _this.setScaleIfSingle(_this.question, _this.assessment);
                if (_this._question.hasFlagCondition) {
                    _this.flagValue = _this._question.flaggedCondition.flagValues;
                    // multiple choice only has a single flag so we go off that.
                    if (_this.question.type == QuestionType.MultipleChoice) {
                        _this.flagDirection = _this._flagDirectionList.find(function (f) { return f.id == _this._question.flaggedCondition.flagDirection; });
                        _this.flagValue = _this.flagValue[0];
                    }
                }
            })
                .catch(function (error) {
                console.error(error);
                _this.router.navigate(["not-found"]);
            });
        });
    };
    QuestionEditComponent.prototype.getQuestionType = function (question) {
        var type = "UNKNOWN";
        switch (question.type) {
            case QuestionType.Checklist:
                {
                    type = "Checklist";
                }
                break;
            case QuestionType.MultipleChoice:
                {
                    type = "Multiple Choice";
                }
                break;
            case QuestionType.SingleChoice:
                {
                    type = "Single Choice";
                }
                break;
            case QuestionType.Textbox:
                {
                    type = "Textbox";
                }
                break;
        }
        return type;
    };
    QuestionEditComponent.prototype.setScaleIfSingle = function (question, assessment) {
        if (assessment && assessment.scales && assessment.scales.length == 1) {
            question.assessment_scale = this.assessment.scales[0];
        }
    };
    Object.defineProperty(QuestionEditComponent.prototype, "scales", {
        get: function () {
            if (this.assessment) {
                return this.assessment.scales;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionEditComponent.prototype, "question", {
        get: function () {
            return this._question;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionEditComponent.prototype, "labels", {
        get: function () {
            return (this.questionSet ? this.questionSet.labels : []);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionEditComponent.prototype, "FlagDirections", {
        get: function () {
            return this._flagDirectionList;
        },
        enumerable: true,
        configurable: true
    });
    QuestionEditComponent.prototype.isChecklistQuestion = function () {
        return this.question.type == QuestionType.Checklist;
    };
    QuestionEditComponent.prototype.isMultipleChoiceQuestion = function () {
        return this.question.type == QuestionType.MultipleChoice;
    };
    QuestionEditComponent.prototype.compareIds = function (a, b) {
        if (!a || !b) {
            return false;
        }
        return a.id === b.id;
    };
    QuestionEditComponent.prototype.toggleFlagQuestion = function (question) {
        var condition = null;
        if (!question.hasFlagCondition) {
            condition = new FlaggedCondition();
        }
        question.flaggedCondition = condition;
    };
    QuestionEditComponent.prototype.hasFlagValue = function (flagValue) {
        if (!this.flagValue) {
            return false;
        }
        return this.flagValue.find(function (fv) { return fv.id == flagValue.id; }) != null;
    };
    QuestionEditComponent.prototype.toggleChecklistFlagValue = function (flagValue) {
        if (this.hasFlagValue(flagValue)) {
            this.flagValue = this.flagValue.filter(function (fv) { return fv.id != flagValue.id; });
        }
        else {
            if (!this.flagValue) {
                this.flagValue = [];
            }
            this.flagValue.push(flagValue);
        }
    };
    QuestionEditComponent.prototype.validateQuestion = function (question) {
        var errors = [];
        if (!question.prompt || question.prompt.trim() == "") {
            errors.push("question prompt cannot be empty");
        }
        if (question.type != QuestionType.Textbox
            && question.type != QuestionType.SingleChoice) {
            if (question.hasFlagCondition) {
                if (!question.flaggedCondition.flagValues.length) {
                    errors.push("Flag criteria must be set, or turn off the flag checkbox");
                }
                if (question.type == QuestionType.MultipleChoice
                    && question.flaggedCondition.flagDirection == "") {
                    errors.push("Flag direction must be set");
                }
            }
        }
        if (!question.assessment_scale) {
            errors.push("This question must have a scale assigned to it before saving");
        }
        return errors;
    };
    QuestionEditComponent.prototype.updateFlagValues = function (question) {
        if (!question.hasFlagCondition) {
            return;
        }
        if (question.type == QuestionType.MultipleChoice) {
            question.flaggedCondition.addFlagValue(this.flagValue);
            question.flaggedCondition.flagDirection = this.flagDirection.id;
        }
        else if (question.type == QuestionType.Checklist) {
            this.flagValue.foreach(function (i) { return question.flaggedCondition.addFlagValue(i); });
        }
    };
    QuestionEditComponent.prototype.getAnswerLabels = function () {
        var labels = this.questionSet.labels;
        if (this.question.type == QuestionType.MultipleChoice
            || this.question.type == QuestionType.Checklist) {
            var listQuestion = this.question;
            labels = listQuestion.CustomLabels;
        }
        return labels;
    };
    QuestionEditComponent.prototype.allowCustomLabels = function () {
        if (this.questionSet
            && this.questionSet.display_type == QuestionSetType.QUESTION_LIST
            && this.question.type != QuestionType.SingleChoice
            && this.question.type != QuestionType.Textbox) {
            return true;
        }
        return false;
    };
    QuestionEditComponent.prototype.saveQuestion = function (question) {
        var _this = this;
        this.isSaving = true;
        this.updateFlagValues(question);
        var errors = this.validateQuestion(question);
        if (errors.length) {
            this.alertService.error(errors.join(".\n"), 3000);
            this.isSaving = false;
            return;
        }
        return this.assessmentService.saveAssessment(this.assessment).then(function (assessment) {
            _this.alertService.success("Question saved", _this.SAVE_TIME);
            _this.isSaving = false;
            return question;
        }).catch(function (error) {
            _this.isSaving = false;
            _this.alertService.error("An error occurred in saving. Please try again or contact support.", _this.ERROR_MESSAGE_TIME);
            console.error(error);
        });
    };
    QuestionEditComponent.prototype.save = function () {
        this.saveQuestion(this.question);
    };
    QuestionEditComponent.prototype.saveAndCreateNew = function () {
        var _this = this;
        this.saveQuestion(this.question).then(function (question) {
            _this.router.navigate(["../../", "new"], { relativeTo: _this.route, replaceUrl: true });
        });
    };
    return QuestionEditComponent;
}());
export { QuestionEditComponent };



// WEBPACK FOOTER //
// ./src/app/admin/question-edit/question-edit.component.ts.pre-build-optimizer.js